var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "linkedin--path-1",
    points: "0 0 16 0 16 15.9998632 0 15.9998632"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-93.000000, -146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "linkedin--mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#linkedin--path-1"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M15.99968,8.09528 C15.94688,12.51288 12.32288,16.05208 7.90528,15.99928 C3.48688,15.94648 -0.05152,12.32248 0.00048,7.90488 C0.05248,3.48648 3.67728,-0.05192 8.09488,8e-05 C12.51328,0.05288 16.05168,3.67768 15.99968,8.09528",
    fill: "#0177B5",
    mask: "url(#linkedin--mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.174193548,2.79183673 L2.24516129,2.79183673 L2.24516129,8.4 L0.174193548,8.4 L0.174193548,2.79183673 Z M1.2,0 C1.85806452,0 2.4,0.448979592 2.4,1.0122449 C2.4,1.56734694 1.86774194,2.0244898 1.2,2.0244898 C0.541935484,2.0244898 0,1.5755102 0,1.0122449 C0,0.457142857 0.541935484,0 1.2,0 L1.2,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,2.54488636 L4.66216216,2.54488636 L4.66216216,3.34602273 L4.68648649,3.34602273 C4.92162162,2.88579545 5.48108108,2.4 6.32432432,2.4 C8.07567568,2.4 8.4,3.61022727 8.4,5.18693182 L8.4,8.4 L6.67297297,8.4 L6.67297297,5.55340909 C6.67297297,4.87159091 6.66486486,4.00227273 5.77297297,4.00227273 C4.87297297,4.00227273 4.73513514,4.74375 4.73513514,5.50227273 L4.73513514,8.4 L3,8.4 L3,2.54488636 Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.1bf93b92.svg";
export { ForwardRef as ReactComponent };